export const languageCodes = [
	{
		code: 'en',
		standardCodes: [
			'en-US',
			'en-CA',
			'en-AE',
			'en-AR',
			'en-AU',
			'en-AT',
			'en-BG',
			'en-BH',
			'en-BR',
			'en-CL',
			'en-CO',
			'en-HR',
			'en-CY',
			'en-CZ',
			'en-DK',
			'en-FI',
			'en-DE',
			'en-GB',
			'en-GR',
			'en-HK',
			'en-HU',
			'en-IS',
			'en-IN',
			'en-ID',
			'en-IE',
			'en-IL',
			'en-KW',
			'en-LV',
			'en-LB',
			'en-MY',
			'en-MT',
			'en-MX',
			'en-NL',
			'en-NZ',
			'en-NO',
			'en-OM',
			'en-PE',
			'en-PL',
			'en-QA',
			'en-RO',
			'en-SA',
			'en-SE',
			'en-SG',
			'en-SK',
			'en-SI',
			'en-TW',
			'en-TH',
			'en-TR',
			'en-ZA',
			'en',
			'en-029',
			'en-BZ',
			'en-JM',
			'en-PH',
			'en-UK',
			'en-ZW',
		],
	},
	{
		code: 'es',
		standardCodes: [
			'es-AR',
			'es-BO',
			'es-CL',
			'es-CO',
			'es-CR',
			'es-DO',
			'es-EC',
			'es-SV',
			'es-GT',
			'es-HN',
			'es-LA',
			'es-MX',
			'es-NI',
			'es-PA',
			'es-PE',
			'es-PY',
			'es-ES',
			'es-US',
			'es-UY',
			'es-419',
			'es',
			'es-PR',
			'es-VE',
		],
	},
	{
		code: 'te',
		standardCodes: ['te-IN'],
	},
]

// Function to determine the user's browser language
export const userBrowserLanguage = () => navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage
